import { Box, IconButton } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { t } from 'ttag';
import React from 'react';

export const columns = ({ editHandler, removeHandler }) => [
  {
    field: 'name',
    headerName: t`Name`,
    sortable: false,
    disableColumnMenu: true,
    flex: 3
  },
  {
    field: 'description',
    headerName: t`Description`,
    sortable: false,
    disableColumnMenu: true,
    flex: 3
  },
  {
    field: 'actions',
    headerName: 'Actions',
    type: 'number',
    sortable: false,
    disableColumnMenu: true,
    flex: 1,
    renderCell: ({ row }) => {
      return (
        <Box>
          <IconButton
            aria-label='edit'
            color='primary'
            onClick={() => editHandler(row)}
            size='small'
          >
            <Edit fontSize='inherit' />
          </IconButton>
          <IconButton
            aria-label='delete'
            onClick={() => removeHandler(row)}
            size='small'
          >
            <Delete fontSize='inherit' />
          </IconButton>
        </Box>
      );
    }
  }
];

export const helper = {
  columns
};

export default helper;
